/**
 * Checkout UX glue (vanilla, działa razem z natywnym Woo wc-checkout.js).
 *
 * Funkcje:
 *  1) Login toggle — "Mam konto" link → show/hide login form panel
 *  2) Payment gateway radio change → show/hide payment_box; trigger update_checkout
 *     (natywny wc-checkout.js robi update przez jQuery; my dodajemy zachowanie show/hide
 *      gdyby ten plik nie miał jQuery dependency)
 *  3) Shipping rate change → trigger update_checkout event (Woo refreshuje review-order)
 *  4) "Wyślij na inny adres?" toggle — pokaż/ukryj .shipping_address container
 *
 * Notatka: Woo checkout używa jQuery — większość natywnych eventów jest na document.body.
 * My zostawiamy mu pełną kontrolę procesu zamówienia; tu robimy tylko display tweaks
 * dla kart payment-method.
 */

(function () {
  if (typeof window === 'undefined') return;

  function $$(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function triggerWooUpdate() {
    // Woo native trigger przez jQuery (jeśli loaded)
    if (window.jQuery) {
      try {
        window.jQuery(document.body).trigger('update_checkout');
      } catch (_) {
        /* noop */
      }
    }
  }

  function initLoginToggle() {
    document.addEventListener('click', (e) => {
      const toggle = e.target.closest('[data-checkout-login-toggle], .showlogin');
      if (!toggle) return;
      e.preventDefault();
      const panel = document.querySelector('[data-checkout-login-panel], .woocommerce-form-login');
      if (panel) {
        panel.classList.toggle('hidden');
        panel.style.display = panel.classList.contains('hidden') ? 'none' : '';
      }
    });
  }

  function initShipToggle() {
    const cb = document.getElementById('ship-to-different-address-checkbox');
    if (!cb) return;
    const wrap = document.querySelector('.shipping_address');
    if (!wrap) return;
    function sync() {
      // Inline style, nie klasa — `hidden` przegrywało z innymi regułami display
      // (Tailwind order + jQuery.slideUp z woocommerce.js zostawia inline none).
      wrap.classList.remove('hidden');
      wrap.style.display = cb.checked ? 'block' : 'none';
    }
    // Idempotent — initShipToggle leci na każdy `updated_checkout` (Woo re-renderuje
    // order_review przez jQuery). Bez tego flagu listener się dublował przy każdym
    // payment/shipping change → na iOS Safari narastały closures.
    if (!cb.__kbShipBound) {
      cb.__kbShipBound = true;
      cb.addEventListener('change', sync);
    }
    sync();
  }

  function initPaymentRadios() {
    document.addEventListener('change', (e) => {
      if (!e.target.matches('input[name="payment_method"]')) return;
      const selectedId = e.target.value;
      $$('.payment_box').forEach((box) => {
        box.style.display = 'none';
      });
      const activeBox = document.querySelector('.payment_method_' + selectedId + ' .payment_box');
      if (activeBox) activeBox.style.display = '';
      triggerWooUpdate();
    });
  }

  function initShippingRadios() {
    document.addEventListener('change', (e) => {
      if (!e.target.matches('input.shipping_method')) return;
      // Natychmiast, nie czekając na AJAX — inaczej pola adresu migają przez
      // ~sekundę przy przełączeniu na paczkomat.
      applyPickupAddressMode();
      triggerWooUpdate();
    });
  }

  // ── Punkt odbioru (paczkomat / ORLEN): nie wymagamy pełnego adresu ──
  //    Poprzednia próba była WYŁĄCZONA, bo chowała pola tylko w JS, a PHP dalej
  //    ich wymagał → „X jest wymaganym polem" przy schowanym polu i klient
  //    utykał. Teraz wymagalność zdejmuje filtr `woocommerce_checkout_fields`
  //    (inc/woocommerce-hooks.php), a JS jest wyłącznie kosmetyką.
  //    Plugin THWCFD field editor, który tamto podejście dodatkowo psuł, nie
  //    jest już zainstalowany — sprawdzone na produkcji.

  // Pola chowane przy punkcie odbioru. MUSI się zgadzać z listą `$drop` w
  // kb_pickup_point filtrze (inc/woocommerce-hooks.php) — PHP zdejmuje im
  // wymagalność, JS chowa je natychmiast po zmianie metody. Rozjazd tych dwóch
  // list = albo widoczne pole bez gwiazdki, albo schowane pole dalej wymagane.
  // Kraj i firma NIE są tu wymienione świadomie — patrz komentarz przy $drop
  // w PHP: ukryty kraj uwięziłby klienta zagranicznego (paczkomat jest domyślny),
  // a firma służy Apaczce jako nazwa odbiorcy.
  const PICKUP_HIDE_FIELD_IDS = ['address_1', 'address_2', 'postcode', 'city', 'state'];

  // Czy wybrany rate to punkt odbioru. Lista rate-id (np. `flat_rate:12`) idzie
  // z PHP (KB.pickupRates), gdzie źródłem prawdy jest ustawienie instancji
  // `display_apaczka_map` pluginu Apaczka. Bez zgadywania z tytułu metody.
  function chosenRateIsPickup() {
    const rates = (window.KB && window.KB.pickupRates) || [];
    if (!rates.length) return false;
    const checked = document.querySelector('input.shipping_method:checked, input[name^="shipping_method"]:checked');
    return !!checked && rates.indexOf(checked.value) !== -1;
  }

  // Chowa/pokazuje wiersze pól adresowych PRZEZ KLASĘ `kb-pickup-hidden`, tę samą,
  // którą server-side dokłada filtr `woocommerce_checkout_fields`. Regułę CSS
  // (z `!important`, żeby pobić utility `.block` z Tailwinda) trzyma tokens.css.
  //
  // Nie używamy tu inline styli, mimo że w initShipToggle() to one były lekarstwem.
  // Powód: przy inline stylach PHP i JS chowałyby pola dwoma różnymi mechanizmami,
  // a przywracanie przez `style.display = ''` odsłaniałoby regułę klasy i pole
  // zostawałoby ukryte. Jeden mechanizm = brak sprzeczności.
  //
  // Pola, które WooCommerce chowa sam (np. `billing_state_field` dla Polski),
  // mają własny inline `display:none` — ten wygrywa z naszą klasą w obie strony,
  // więc nie musimy ich specjalnie pilnować.
  function applyPickupAddressMode() {
    const pickup = chosenRateIsPickup();
    ['billing', 'shipping'].forEach((group) => {
      PICKUP_HIDE_FIELD_IDS.forEach((suffix) => {
        const row = document.getElementById(`${group}_${suffix}_field`);
        if (!row) return;
        row.classList.toggle('kb-pickup-hidden', pickup);
      });
    });
  }

  function initPickupAddressMode() {
    applyPickupAddressMode();
  }

  function initCouponToggle() {
    document.addEventListener('click', (e) => {
      const toggle = e.target.closest('[data-kb-coupon-toggle]');
      if (!toggle) return;
      e.preventDefault();
      const panel = document.querySelector('[data-kb-coupon-panel]');
      const chev = document.querySelector('[data-kb-coupon-chevron]');
      if (!panel) return;
      const isHidden = panel.classList.contains('hidden');
      panel.classList.toggle('hidden');
      toggle.setAttribute('aria-expanded', String(isHidden));
      if (chev) {
        chev.style.transform = isHidden ? 'rotate(180deg)' : '';
      }
      if (isHidden) {
        const inp = document.getElementById('coupon_code');
        if (inp) inp.focus();
      }
    });
  }

  function initCouponApply() {
    // Enter w polu kodu = „Zastosuj". Pole leży w formularzu kasy, więc bez tego Enter składał zamówienie.
    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Enter' || !e.target.closest || !e.target.closest('form.checkout #coupon_code')) return;
      e.preventDefault();
      document.querySelector('[data-kb-apply-coupon]')?.click();
    });
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-kb-apply-coupon]');
      if (!btn) return;
      e.preventDefault();
      const input = document.getElementById('coupon_code');
      const feedback = document.querySelector('[data-kb-coupon-feedback]');
      if (!input || !input.value.trim()) {
        input?.focus();
        return;
      }
      if (!window.jQuery || !window.wc_checkout_params) {
        if (feedback) {
          feedback.textContent = 'Spróbuj ponownie za chwilę.';
          feedback.classList.remove('hidden', 'text-emerald-700');
          feedback.classList.add('text-[#b23b3b]');
        }
        return;
      }
      const code = input.value.trim();
      btn.disabled = true;
      btn.textContent = '...';
      if (feedback) {
        feedback.classList.add('hidden');
        feedback.textContent = '';
      }
      window.jQuery.ajax({
        type: 'POST',
        url: window.wc_checkout_params.wc_ajax_url.toString().replace('%%endpoint%%', 'apply_coupon'),
        data: {
          security: window.wc_checkout_params.apply_coupon_nonce || '',
          coupon_code: code,
          billing_email: (document.getElementById('billing_email') || {}).value || '',
        },
        success: (response) => {
          const html = String(response || '');
          const isError = html.indexOf('woocommerce-error') !== -1;
          if (feedback) {
            feedback.classList.remove('hidden', 'text-emerald-700', 'text-[#b23b3b]');
            if (isError) {
              feedback.classList.add('text-[#b23b3b]');
              // Powód z serwera (minimalna kwota, limit użyć, inny e-mail) zamiast jednej formułki.
              const powod = new DOMParser().parseFromString(html, 'text/html').body.textContent.replace(/\s+/g, ' ').trim();
              feedback.textContent = powod || 'Kupon nieprawidłowy lub wygasł.';
              input.focus();
            } else {
              feedback.classList.add('text-emerald-700');
              feedback.textContent = 'Kupon zastosowany.';
              input.value = '';
            }
          } else if (!isError) {
            input.value = '';
          }
        },
        error: () => {
          if (feedback) {
            feedback.classList.remove('hidden');
            feedback.classList.add('text-[#b23b3b]');
            feedback.textContent = 'Błąd połączenia. Spróbuj ponownie.';
          }
        },
        complete: () => {
          btn.disabled = false;
          btn.textContent = 'Zastosuj';
          if (window.jQuery) {
            try { window.jQuery(document.body).trigger('update_checkout'); } catch (_) {}
          }
        },
      });
    });
  }

  // Imoje regulations — checkbox renderowany server-side w PHP hook
  // `woocommerce_review_order_before_submit` (inc/woocommerce-hooks.php).
  // JS-based inject był zawodny bo imoje re-rendowi `.imoje-regulations`
  // przy każdym updated_checkout — server-side jest persistent.
  function injectImojeConsent() {
    // No-op — checkbox jest w PHP. Funkcja zostaje jako stub żeby init() + updated_checkout
    // listener mogły ją wciąż wywoływać bez błędu.
  }

  // ── Express pay z PDP ──
  // Klient kliknął Apple Pay / Google Pay na karcie produktu → KB.expressWallet
  // (jednorazowo z sesji, inc/enqueue.php). Zaznaczamy bramkę paynow „portfele
  // cyfrowe" + radio konkretnego portfela (rozpoznanie po alt/src obrazka metody,
  // bo paynow nadaje im numeryczne ID). Retry przez updated_checkout — sekcja
  // płatności renderuje się asynchronicznie; po skutecznym zaznaczeniu gasimy
  // flagę, żeby nie walczyć z późniejszym ręcznym wyborem klienta.
  function applyExpressWallet() {
    const wallet = window.KB && window.KB.expressWallet;
    if (!wallet) return;
    const gw = document.getElementById('payment_method_pay_by_paynow_pl_digital_wallets');
    if (!gw) return;
    if (!gw.checked) {
      gw.checked = true;
      gw.dispatchEvent(new Event('change', { bubbles: true }));
      if (window.jQuery) window.jQuery(gw).trigger('change');
    }
    const sub = Array.from(
      document.querySelectorAll('.payment_method_pay_by_paynow_pl_digital_wallets input[name="paymentMethodId"]')
    ).find((i) => {
      const img = (i.closest('.paynow-payment-option-pbl') || i.parentElement || document).querySelector('img');
      return img && new RegExp(wallet, 'i').test((img.alt || '') + ' ' + (img.src || ''));
    });
    if (sub && !sub.checked) {
      sub.checked = true;
      sub.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (sub) window.KB.expressWallet = '';
  }

  function init() {
    // Tylko na checkout page
    if (!document.querySelector('form.woocommerce-checkout')) return;
    initLoginToggle();
    initShipToggle();
    initPaymentRadios();
    initShippingRadios();
    initPickupAddressMode();
    initCouponToggle();
    initCouponApply();
    injectImojeConsent();
    [150, 600, 1500].forEach((delay) => setTimeout(applyExpressWallet, delay));

    // Retry kilka razy z opóźnieniem — pierwszy load:
    // - WC odpala swój `wc-checkout.js` po naszym DOMContentLoaded
    // - Apaczka.pl Mapa Punktów renderuje swój widget asynchronicznie
    // - chosen_shipping_methods może nie być w pełni zsynchronizowane
    // Bez tych retry pola adresowe NIE chowają się na 1. wejściu na checkout
    // gdy paczkomat jest pre-selected (tylko po manualnym kliknięciu radio).
    [100, 400, 1000, 2000].forEach((delay) => {
      setTimeout(applyPickupAddressMode, delay);
    });

    // Wymuś update_checkout po init żeby WC zsynchronizował stan
    // i odpalił nasz `updated_checkout` listener (poniżej).
    if (window.jQuery) {
      setTimeout(() => {
        try { window.jQuery(document.body).trigger('update_checkout'); } catch (_) {}
      }, 250);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-attach po Woo updated_checkout — Woo re-renderuje order_review przez jQuery
  // i niektóre listenery (kontener review-order) mogą wymagać re-init.
  function onCheckoutUpdated() {
    initShipToggle();
    initPickupAddressMode();
    injectImojeConsent();
    applyExpressWallet();
  }

  // WooCommerce triggeruje `updated_checkout` przez jQuery, a jQuery.trigger()
  // NIE emituje natywnego DOM eventu — natywny addEventListener poniżej sam by
  // się nigdy nie odpalił. Dlatego główny nasłuch idzie przez jQuery, a natywny
  // zostaje jako zapas (gdyby kiedyś ktoś odpalił prawdziwy CustomEvent).
  if (window.jQuery) {
    window.jQuery(document.body).on('updated_checkout', onCheckoutUpdated);
  }
  document.body.addEventListener('updated_checkout', onCheckoutUpdated);

  // Bonus: nasłuchuj WC native event-u kiedy Apaczka picker zaktualizuje punkt
  // (mutation observer na zmianie `apm_access_point_id`). Wtedy też odpal.
  const apmInput = document.getElementById('apm_access_point_id');
  if (apmInput) {
    new MutationObserver(() => applyPickupAddressMode()).observe(apmInput, {
      attributes: true,
      attributeFilter: ['value'],
    });
  }
})();
